import { Region } from "../../model"

export function getRegion(regions: Region[], id: number): Region {
	return regions.find(r => r.id === id) || null
}


// WEBPACK FOOTER //
// ./src/domain/sfp/region-domain.ts